<template>
  <Section background="fill-4" v-observe-visibility="intObseverCfg" :slanted="1" :height="100" pad-h>
    <div class="container">
      <Logo class="logo" />
      <Menu class="menu" />
    </div>
  </Section>
</template>

<script>
import { mapState } from 'vuex';
import Menu from '@/components/Menu.vue';
import Logo from '@/components/Logo.vue';

export default {
  name: 'Footer',

  components: { Menu, Logo },

  data() {
    return {
      intObseverCfg: {
        callback: this.setTopic,
        intersection: {
          rootMargin: '-400px',
        },
      },
    };
  },

  computed: mapState(['isScrolling']),

  methods: {
    setTopic: function (isVisible) {
      if (isVisible && !this.isScrolling) {
        this.$router.push({ path: '#contact', query: { scroll: false } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
}

.menu {
  display: none;
  margin-left: auto;

  @include respond-to('small') {
    display: block;
  }
}
</style>
